/*
 * @Description: 命名与排序
 * @Author: 杨志航
 * @Date: 2026-09-15 17:50:33
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import Main from './Main'
import GroupSetting from './GroupSetting'

const NameSort = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/groupsetting'} component={GroupSetting} />
      <CacheRoute component={Main} />
    </CacheSwitch>
  )
}

export default NameSort